const Handlebars = require('handlebars/dist/cjs/handlebars.runtime');
const SHA256 = require('sha256');
const moment = require('moment/moment');

Handlebars.registerHelper('getTemplate', function (templates, templateId, version, prop) {
    return templates[templateId][version][prop];
});

Handlebars.registerHelper('getTemplatesAvailableVersion', function (templates, templateId, prop) {
    if (!templates || !templates[templateId]) {
        return '';
    }
    const availableVersions = Object.keys(templates[templateId]);
    if (!availableVersions || !availableVersions.length) {
        return '';
    }
    return templates[templateId][availableVersions[0]][prop];
});

Handlebars.registerHelper('checkTemplateProp', function (templates, templateId, version, prop, options) {
    return templates[templateId] &&
        templates[templateId][version] &&
        templates[templateId][version][prop] &&
        templates[templateId][version][prop].length &&
        (templates[templateId][version][prop].length > 1 || templates[templateId][version][prop][0] !== '')
        ? options.fn(this)
        : options.inverse(this);
});

Handlebars.registerHelper('checkTemplateProps',
    function (templates, templateId, version, prop1, prop2, prop3, prop4, options) {
        const props = [prop1, prop2, prop3, prop4];
        if (templates[templateId] &&
            templates[templateId][version]) {
            const template = templates[templateId][version];
            for (let i = 0; i < props.length; i++) {
                if (template[props[i]] &&
                    template[props[i]].length) {
                    return options.fn(this);
                }
            }
        }
        return options.inverse(this);
    }
);

Handlebars.registerHelper('printTemplatePropIfExist', function (templates, templateId, version, prop) {
    if (templates[templateId] &&
        templates[templateId][version] &&
        templates[templateId][version][prop] &&
        templates[templateId][version][prop].length) {
        return '<div class="uc-consent-description">'
            + '<p>' + templates[templateId][version][prop] + '</p>'
            + '</div>';
    }
    return '';
});

Handlebars.registerHelper('printLinkTemplatePropIfExist', function (templates, templateId, version, prop, label) {
    if (templates[templateId] &&
        templates[templateId][version] &&
        templates[templateId][version][prop] &&
        templates[templateId][version][prop].length) {
        const url = templates[templateId][version][prop];
        return '<div class="uc-consent-description">'
            + '<p>' + label + ' <a href="' + url + '" target="_blank" rel="nofollow">' + url + '</a></p>'
            + '</div>';
    }
    return '';
});

Handlebars.registerHelper('breakText', function (text) {
    return text.replace(/(\r\n|\n|\r)/gm, '<br>');
});

Handlebars.registerHelper('consentDescription', function (templates, templateId, version, description) {
    if (description && description.length) {
        return description.replace(/(\r\n|\n|\r)/gm, '<br>');
    } else if (templates && templates[templateId] && typeof templates[templateId][version].descriptionOfService !== 'undefined') {
        return templates[templateId][version].descriptionOfService.replace(/(\r\n|\n|\r)/gm, '<br>');
    }

    return '';
});

Handlebars.registerHelper('getTemplatePropList', function (templates, templateId, version, prop) {
    if (
        templates[templateId][version] &&
        templates[templateId][version][prop] &&
        templates[templateId][version][prop].length
    ) {
        let value = templates[templateId][version][prop];
        if (!Array.isArray(value)) {
            value = [value];
        }
        let classes = '';
        if (templates[templateId][version][prop].length > 3) {
            classes = 'uc-flex-container uc-flex-2';
        }
        return '<ul class="' + classes + '"><li class="uc-flex-item ls-dash">'
            + value.join('</li><li class="uc-flex-item ls-dash">')
            + '</li></ul>';
    }
    return '';
});

Handlebars.registerHelper('checkTemplateFeaturesList',
    function (templates, templateId, version, vendors, options) {
        return checkFieldExist(templates, templateId, version, vendors, options, 'featureIds');
    }
);

const checkFieldExist = function (templates, templateId, version, vendors, options, fieldName) {
    if (vendors) {
        const vendor = getVendor(templates, templateId, version, vendors);

        if (vendor && vendor[fieldName] && vendor[fieldName].length > 0) {
            return options.fn(this);
        }
    }
    return options.inverse(this);
};

const getVendor = function (templates, templateId, version, vendors) {
    if (vendors) {
        for (let index = 0; index < vendors.length; index++) {
            const vendor = vendors[index];
            if (vendor.id === Number(templates[templateId][version].iabId)) {
                return vendor;
            }
        }
    }

    return null;
};


Handlebars.registerHelper('getTemplateFeaturesList', function (templates, templateId, version, vendors, features) {
    if (vendors === null) {
        return '';
    }
    const vendor = iabHelperFunctionGetVendor(templates, templateId, version, vendors);
    if (vendor === null) {
        return '';
    }

    const mappedFeatures = vendor.featureIds.map(function (id) {
        for (let i = 0; i < features.length; i++) {
            if (features[i].id === id) {
                return '<b>' + features[i].name + '</b><br/>' + features[i].description;
            }
        }
        return '';
    });
    if (
        mappedFeatures &&
        mappedFeatures.length
    ) {
        return '<ul><li class="uc-flex-item ls-dash">' + mappedFeatures.join('</li><li class="uc-flex-item ls-dash">') + '</li></ul>';
    }
    return '';
});

Handlebars.registerHelper('isPurposeSelected', function (id, purposeStatus, options) {
    if (purposeStatus[id]) {
        return options.fn(this);
    }
    return options.inverse(this);
});

Handlebars.registerHelper('purposeCheckbox', function (purpose, purposeStatus, prefix) {
    const checkbox = require('../components/atoms/input/checkbox/checkbox.hbs');
    return checkbox({
        isChecked: purposeStatus[purpose.id],
        isDisabled: false,
        shortid: purpose.id,
        labelPosition: 'left',
        customContainerClass: 'uc-consent-title',
        isLabelHidden: true,
        dataScrollanchor: purpose.id,
        prefix: prefix || ''
    });
});

Handlebars.registerHelper('checkTemplatePurposesList',
    function (templates, templateId, version, vendors, options) {
        return checkFieldExist(templates, templateId, version, vendors, options, 'purposeIds');
    }
);

Handlebars.registerHelper('getTemplatePurposesList',
    function (templates, templateId, version, vendors, purposes) {
        const vendor = getVendor(templates, templateId, version, vendors);
        if (vendor === null) {
            return '';
        }

        const convertedPurpose = purposes.filter(function (purpose) { return vendor.purposeIds.indexOf(purpose.id) > -1; })
            .map(function (purpose) {
                return '<b>' + purpose.name + ' (Legal Base: Consent)</b></br>' + purpose.description;
            });

        if (convertedPurpose && convertedPurpose.length) {
            return '<ul><li class="uc-flex-item ls-dash" style="margin-bottom: 12px;">' + convertedPurpose.join('</li><li class="uc-flex-item ls-dash" style="margin-bottom: 12px;">') + '</li></ul>';
        }
        return '';
    }
);

const iabHelperFunctionGetVendor = function (templates, templateId, version, vendorList) {
    let iabId;
    if (
        templates[templateId][version]
    ) {
        iabId = Number(templates[templateId][version].iabId);
        if (!iabId) {
            return null;
        }

        let vendor = null;
        for (let i = 0; i < vendorList.length; i++) {
            if (vendorList[i].id === iabId) {
                vendor = vendorList[i];
            }
        }
        return vendor;
    }
    return null;

};


Handlebars.registerHelper('getConsentId', function (consent, settingsId) {
    return SHA256(
        settingsId + '_' + JSON.stringify([consent.controllerId]) + '_' + JSON.stringify([consent.processorId])
    );
});

Handlebars.registerHelper('checkSectionVisibility', function (fieldId, toggleFields, section, options) {
    return toggleFields[fieldId] && toggleFields[fieldId][section]
        ? options.fn(this)
        : options.inverse(this);
});

Handlebars.registerHelper('checkFieldStatus', function (fieldId, toggleFields, options) {
    return toggleFields[fieldId]
        ? options.fn(this)
        : options.inverse(this);
});


Handlebars.registerHelper('printCopyLabel', function (consent, key, property, labels) {
    return key[consent.templateId][property] ? labels.copied : labels.copy;
});

Handlebars.registerHelper('setHistoryLabel', function (history, historyDateFormat) {
    const updateDate = new Date(history.updatedAt);
    switch (historyDateFormat) {
        case 1:
            return moment(updateDate).format('DD/MM/YY, H:mm');
        case 2:
            return moment(updateDate).format('DD.MM.YY, H:mm');
        case 3:
            return moment(updateDate).format('DD.MM.YYYY, H:mm');
        default:
            return moment(updateDate).fromNowOrNow();
    }
});

Handlebars.registerHelper('lightOrDark', function (color) {
    const LIGHT_COLOR = 'fff';
    const DARK_COLOR = '021836';
    const MAXIMUM_LUMINANCE = .5;

    color = color.indexOf('#') > -1 ? color : '#' + color;
    color = Number('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));

    const r = color >> 16;
    const g = color >> 8 & 255;
    const b = color & 255;
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    return luminance > MAXIMUM_LUMINANCE ? DARK_COLOR : LIGHT_COLOR;
});

module.exports = Handlebars;
